import { TableHeadersType } from "../../tableHeadersType";

export const GENERAL_LEDGER_TABLE_HEADERS:TableHeadersType[]=[
    {
        label:"Date",
        value:"date",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Ledger Name",
        value:"Ledger_name",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Invoice NO.",
        value:"Invoice_no",
        checked:true,
        defaultChecked:true
    },
    {
        label:"narration",
        value:"narration",
        checked:true,
        defaultChecked:true
    },
   
    {
        label:"voucher type",
        value:"voucher_type",
        checked:true,
        defaultChecked:true
    },
   
    {
        label:"debit",
        value:"debit_amount",
        checked:true,
        defaultChecked:true
    },
    {
        label:"credit",
        value:"credit_amount",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Balance",
        value:"balance",
        checked:true,
        defaultChecked:true
    }
]